<script setup>
import AppLayout from '@/Layouts/AppLayout'
import { useForm } from '@inertiajs/inertia-vue3'

const props = defineProps({
    user: Object,
    roles: Object,
})


const form = useForm({
    name: props.user.name,
    password: null,
    email: props.user.email,
    rol: props.user.roles && props.user.roles.length > 0 ? props.user.roles[0].name : null
});
</script>

<template>
    <AppLayout>
        <div class="card">
            <div class="card-body py-3">
                <el-form @submit.prevent="submit()" class="form">
                    <div class="mb-13 text-center">
                        <h1 class="mb-3">Editar Usuario</h1>
                    </div>

                    <div class="d-flex flex-column mb-8 fv-row">
                        <label class="d-flex align-items-center fs-6 fw-semobold mb-2">
                            <span class="required">Nombre de usuario</span>
                            <i class="fas fa-exclamation-circle ms-2 fs-7" data-bs-toggle="tooltip"
                                title="Specify a target name for future usage and reference"></i>
                        </label>

                        <el-form-item prop="name">
                            <el-input v-model="form.name" name="name"></el-input>
                            <div class="el-form-item__error" v-if="props.errors.name">
                                {{ props.errors.name }}
                            </div>
                        </el-form-item>

                        <label class="d-flex align-items-center fs-6 fw-semobold mb-2">
                            <span class="required">Correo electrónico</span>
                            <i class="fas fa-exclamation-circle ms-2 fs-7" data-bs-toggle="tooltip"
                                title="Specify a target name for future usage and reference"></i>
                        </label>

                        <el-form-item prop="email">
                            <el-input v-model="form.email" name="email"></el-input>
                            <div class="el-form-item__error" v-if="props.errors.email">
                                {{ props.errors.email }}
                            </div>
                        </el-form-item>

                        <label class="d-flex align-items-center fs-6 fw-semobold mb-2">
                            <span class="required">Contraseña</span>
                            <i class="fas fa-exclamation-circle ms-2 fs-7" data-bs-toggle="tooltip"
                                title="Specify a target name for future usage and reference"></i>
                        </label>
                        <el-form-item prop="password">
                            <el-input v-model="form.password" name="password" type="password"></el-input>
                            <div class="el-form-item__error" v-if="props.errors.password">
                                {{ props.errors.password }}
                            </div>
                        </el-form-item>

                        <div class="d-flex flex-column mb-8 fv-row">
                            <label class="d-flex align-items-center fs-6 fw-semobold mb-2">
                                <span class="required">Rol</span>
                                <i class="fas fa-exclamation-circle ms-2 fs-7" data-bs-toggle="tooltip"
                                    title="Specify a target name for future usage and reference"></i>
                            </label>

                            <select v-model="form.rol" class="form-select form-select-lg mb-3"
                                aria-label="form-select-lg example" id="rol">
                                <option v-for="rol in roles" :key="rol.id" :value="rol.name">
                                    {{ rol.name }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="text-end">
                        <Link :href="route('users.index')" class="btn btn-lg btn-dark">
                            Cancelar
                            <span class="svg-icon svg-icon-3 ms-2 me-0">
                                <inline-svg src="/images/icons/duotune/arrows/arr088.svg" />
                            </span>
                        </Link>
                        <button type="submit" class="ms-2 btn btn-lg btn-primary">
                            Guardar
                            <span class="svg-icon svg-icon-3 ms-2 me-0">
                                <inline-svg src="/images/icons/duotune/arrows/arr064.svg" />
                            </span>
                        </button>
                    </div>
                </el-form>
            </div>
        </div>
    </AppLayout>
</template>
